import React, { lazy, Suspense, useState } from 'react'
import Navigation from '../navigation/Navigation'
import Footer from '../navigation/Footer'
import { DotPattern } from './DotPattern'

// Loaded on first use so the form's MUI fields stay out of the landing page bundle.
const ContactModal = lazy(() => import('../modals/ContactModal'))

interface LayoutProps {
  children: React.ReactNode
}

export default function Layout({ children }: LayoutProps) {
  const [contactOpen, setContactOpen] = useState(false)
  const [contactLoaded, setContactLoaded] = useState(false)

  const openContact = () => {
    setContactLoaded(true)
    setContactOpen(true)
  }

  return (
    <div className="relative min-h-svh bg-background overflow-x-hidden">
      {/* Background layers - behind all content */}
      <DotPattern />
      <div className="fixed inset-0 pointer-events-none topo-bg" style={{ zIndex: 0 }} />

      {/* Content - above background layers. The footer sits at the bottom of
          the viewport on short pages and after the content on long ones. */}
      <div className="relative flex min-h-svh flex-col" style={{ zIndex: 1 }}>
        <Navigation />
        <main className="relative flex-1">
          {children}
        </main>
        <Footer onContact={openContact} />
      </div>

      {contactLoaded && (
        <Suspense fallback={null}>
          <ContactModal isOpen={contactOpen} onClose={() => setContactOpen(false)} />
        </Suspense>
      )}
    </div>
  )
}
